import { useSwitchablePlansQuery } from "services/graphql";

export const useSwitchablePlans = () => {
  const { data, loading, error, refetch } = useSwitchablePlansQuery();

  return { data, loading, error, refetch };
};
